import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'

let apiBaseUrl = process.env.VUE_APP_BASE_URL;
let chatBaseUrl = process.env.VUE_APP_CHAT_BASE_URL;
let nlpBaseUrl = process.env.VUE_APP_NLP_BASE_URL;
let uploadsBaseUrl = process.env.VUE_APP_UPLOADS_URL;
let sessionManagerBaseUrl = process.env.VUE_APP_SESSION_MANAGER_BASE_URL
let facebookAutoProvision = process.env.VUE_APP_FACEBOOK_AUTO_PROVISION_BASE_URL
let autoProvisionBaseUrl = process.env.VUE_APP_AUTO_PROVISION_BASE_URL
let gatewayBaseUrl = process.env.VUE_APP_GATEWAY
let twitterBaseUrl = process.env.VUE_APP_TWITTER_SUBSCRIPTION_URL
let licenceManagerBaseUrl = process.env.VUE_APP_LICENCE_MANAGER_BASE_URL
let cubeBaseUrl = process.env.VUE_APP_CUBE_BASE_URL

// console.log(apiBaseUrl, nlpBaseUrl, process.env)



// Vue.prototype.$http = axios

Vue.prototype.$http_noauth = axios.create({
  baseURL: apiBaseUrl,
  headers: {

  }
})

const userToken = localStorage.getItem('userToken')
const botId = localStorage.getItem('botId')
const accessToken = localStorage.getItem('accessToken')

Vue.prototype.$http = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`,
  }
})

Vue.prototype.$http_chat = axios.create({
  baseURL: chatBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`
  }
})

Vue.prototype.$http_multipart = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`,
    "Content-Type": "multipart/form-data; boundary=MultipartBoundry",
  }
})

Vue.prototype.$http_uploads = axios.create({
  baseURL: uploadsBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`,
    "Content-Type": "multipart/form-data; boundary=MultipartBoundry",
  }
})

Vue.prototype.$http_without_base = axios.create({

})


Vue.prototype.$http_bot = axios.create({
  baseURL: apiBaseUrl,
  params: {
    bot_id: botId
  },
  headers: {
    'Authorization' : `Bearer ${userToken}`,
  }
})



Vue.prototype.$http_nlp = axios.create({
  baseURL: nlpBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`
  }
})

Vue.prototype.$http_nlp_bot = axios.create({
  baseURL: nlpBaseUrl,
  params: {
    'filter[bot_id]': botId
  },
  headers: {
    'Authorization' : `Bearer ${userToken}`
  }
})


Vue.prototype.$http_session_manager = axios.create({
  baseURL: sessionManagerBaseUrl,
  headers: {
    'Authorization' : `Bearer ${userToken}`,
  }
})

Vue.prototype.$http_auto_provision = axios.create({
  baseURL: autoProvisionBaseUrl,
})


Vue.prototype.$http_facebook_auto_provision = axios.create({
  baseURL: facebookAutoProvision,
})

Vue.prototype.$http_gateway = axios.create({
  baseURL: gatewayBaseUrl,
})

Vue.prototype.$http_licence= axios.create({
  baseURL: licenceManagerBaseUrl,
})

Vue.prototype.$http_twitter = axios.create({
  baseURL: twitterBaseUrl,
})

Vue.prototype.$http_cube = axios.create({
  baseURL: cubeBaseUrl,
})





Vue.prototype.$http_bot.interceptors.response.use((response) => {
  checkAccess(response)
  return response;
}, (error) => {
  console.log(`error ${error}`);
  return Promise.reject(error);
})

Vue.prototype.$http.interceptors.response.use((response) => {
  checkAccess(response)
  if(response.status >= 400){
    return Promise.reject(response.data && response.data.detail);
  }
  return response;
}, (error) => {
  console.log(`error ${error}`);
  return Promise.reject(error.response.data && error.response.data.detail || error);
})


Vue.prototype.$http_bot.interceptors.request.use((config) => {
  if (botId && config) {
    config.headers['access-key'] = `${accessToken},${botId},${localStorage.getItem('currentRoute')}`

  }
  return config;
}, (error) => {
  console.log(`error ${error}`);
  return Promise.reject(error);
})

Vue.prototype.$http.interceptors.request.use((config) => {
  if (botId && config) {
    config.headers['access-key'] = `${accessToken},${botId},${localStorage.getItem('currentRoute')}`

  }
  return config;
}, (error) => {
  console.log(`error ${error}`);
  return Promise.reject(error);
})

function checkAccess (response) {
  if(response.headers['can-access'] === 'false') {
    store.dispatch('setSnackbar', {
      text: `Warning , another user editing on the same page`,
      color: 'error'
    })
  }
}
